import { jsx } from 'react/jsx-runtime';
import '../tabs-primitive/tab-panel-primitive.js';
import '../tabs-primitive/tab-primitive.js';
import { TabStripPrimitive } from '../tabs-primitive/tab-strip-primitive.js';
import 'react';
import 'tabbable';
import '../utils/interaction.js';
import { tabStrip } from './tabs.css.js';

/**
 * Tab strips allow users to navigate between two or more related views.
 *
 * @compose { "root": true }
 * @see https://fpl.figma.design/components/tabs/
 */
function TabStrip(props) {
    return jsx(TabStripPrimitive, { "data-fpl-component": "", ...props, className: tabStrip });
}
TabStrip.displayName = 'Tabs.TabStrip';

export { TabStrip };
//# sourceMappingURL=tab-strip.js.map
